<template>
  <div class="b">
    <Nav :current="current"></Nav>
    <el-tabs type="border-card" @tab-click="handleClick">
      <el-tab-pane label="服务器资源信息">
        <el-table
          :data="listName0"
          empty-text=""
          style="width: 100%">
          <el-table-column 
            v-for="(item,index) in listCol0" 
            :prop="item.prop" :label="item.label" 
            :key="index"
            :type="item.type">
            <template v-if="item.prop == 'value'" scope="scope">
              <b>{{scope.row.value}}</b>
            </template>
            </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="redis信息">
        <el-table
          :data="listName1"
          empty-text=""
          style="width: 100%">
          <el-table-column 
            v-for="(item,index) in listCol0" 
            :prop="item.prop" :label="item.label" 
            :key="index"
            :type="item.type">
              <template v-if="item.prop == 'value'" scope="scope">
                <b>{{scope.row.value}}</b>
              </template>
            </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="redis中缓存的对象信息">
        <div class="el-table-box">
          <el-table
            :data="list2"
            empty-text=""
            style="width: 100%">
            <el-table-column
              :prop="col.prop"
              :label="col.label"
              :min-width="col.minwidth"
              :width="col.width"
              :fixed="col.fixed"
              :type="col.type"
              show-overflow-tooltip
              v-for="(col, index) in listCol"
              :key="index"
            >
              <template v-if="col.prop == 'objNum'" scope="scope">
                <b>{{scope.row.objNum}}</b>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Search from "@/components/Search.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import axios from "axios";
import qs from "qs";
// let timmer
export default {
  components: {
    Nav,
  },
  data() {
    return {
      current: "公司后台",
      index: 0,
      currentPage: 1,
      pageSize: 10,
      total: 10,
      listCol0: [
        {
          label: "序号",
          type: "index",
          width: "50",
        },
        {
          label: '参数',
          prop: "desc",
        },
        {
          label: '参数值',
          prop: "value",
        },
        {
          label: 'ID',
          prop: "name",
        },

      ],
      listName0: [
        { name: 'ipAddress', desc: '服务器IP'},
        { name: 'osName',desc: '操作系统名称' },
        { name: 'osVersion', desc: '操作系统版本' },
        { name: 'percentCpuLoad', desc: 'CPU占用率' },
        { name: 'totalPhysicalMemorySize', desc: '操作系统总内存' },
        { name: 'freePhysicalMemorySize', desc: '操作系统可用内存' },
        { name: 'percentMemoryLoad', desc: '操作系统内存占用率' },
        { name: 'pid', desc: '当前JAVA进程ID' },
        { name: 'heapInitSize', desc: '堆空间初始化内存' },
        { name: 'heapUsedSize', desc: '堆空间可用内存' },
        { name: 'heapMaxSize', desc: '堆空间最大内存' },
        { name: 'noheapInitSize', desc: '非堆空间初始化内存' },
        { name: 'noheapUsedSize', desc: '非堆空间可用内存' },
        { name: 'noheapMaxSize', desc: '非堆空间最大内存'},
      ],
      listName1: [
        {name: 'usedMemory',desc: 'redis分配的内存总量,也就是内部存储的所有数据内存占用量'},
        {name: 'usedMemoryRss', desc: '从操作系统角度返回redis使用内存数，与linux中top，ps命令返回数据一致。除了分配器分配的内存之外，used_memory_rss还包括进程运行本身需要的内存、内存碎片等，但是不包括虚拟内存'},
        {name: 'usedMemoryPeak',desc: '内存使用的最大值，表示 used_memory 的峰值'},
        {name: 'dbsize',desc: '查看当前数据库的有效key数量'},
        {name: 'totalCommandSprocessed',desc: '服务器已执行的命令数量'},
        {name: 'instantaneousopsperSec',desc: '服务器每秒钟执行的命令数量'},
      ],
      list0: [],
      list1: [],
      list2: [],
      listCol: [
        {
          label: "序号",
          type: "index",
          width: "50",
        },
        {
          label: '对象名称',
          prop: "objName",
        },
        {
          prop: "objNum",
          label: "对象数量",
        },
      ],
    };
  },
  mounted() {
    // if(timmer){
    //   clearInterval(timmer)
    // }
    this.getList(1)
  },
  methods: {
    handleClick(tab) {
      this.index = tab.index
      // if(timmer){
      //   clearInterval(timmer)
      // }
      // if(tab.index == 2){
      //   timmer = setInterval(() => {
      //     this.getList(parseInt(tab.index) + 1,true)
      //   }, 5000);
      // }
      this.getList(parseInt(tab.index) + 1)
    },
    requst(type) {
      let _this = this
      let url = ``
      if(type == 1){
        url = apiData.getServerResourceInfo
      }else if(type == 2){
        url = apiData.getCacheInfo
      }else if(type == 3){
        url = apiData.getCacheObjList
      }
      http.get(url, true, {}, (res) => {
        let data = res.data.data
        if(res && data){
          if(type != 3){
            _this[`listName${_this.index}`] = _this[`listName${_this.index}`].map((item) =>{
              if(data[item.name]){
                item['value'] = data[item.name]
              }
              return item
            })
          }else {
            _this[`list${_this.index}`] = res.data.data
          }
        }
      });
    },
    getList(type) {
      this.requst(type)
    }
  },
};
</script>
<style lang="less">
#app {
  height: 100%;
}
.b {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  .el-tabs {
    flex: 1;
    overflow: auto;
    margin-bottom: 15px;

  }
}

</style>